/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-14 15:24:58
 * @Description: 
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/shareic/static.js
 */
import icon1 from "../../img/web_icon_youtube.png"
import icon2 from "../../img/web_icon_.png"
import icon3 from "../../img/web_icon_twitter.png"
import icon4 from "../../img/web_icon_discord.png"


export const shareList = [
  {
    img: icon1,
    link: "https://www.youtube.com/channel/UCMyaX-d68MK61eknN2-yGtw",
  },
  {
    img: icon2,
    link: "https://www.facebook.com/vrstarmaker/?ref=page_internal",
  },
  {
    img: icon3,
    link: "https://twitter.com/starmakervr",
  },
  {
    img: icon4,
    link: "https://discord.gg/cAzMrbf3qj",
  },
]